import React, { useEffect, useRef, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  CardElement,
  Elements,
  useStripe,
  useElements,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from "@stripe/react-stripe-js";
import { useDispatch } from "react-redux";
import {
  applyPromocodeWizard,
  removePromocodeWizard,
  saveSetupWizardForm,
  showNotificationWithTimeout,
} from "../../Redux/actions";
import { checkNull } from "../../helpers";

const CheckoutForm = ({ isSubmit, submitBtnHandler, purchased_plan }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (isSubmit) {
      buttonRef.current.click();
    }
  }, [isSubmit]);

  const stripe = useStripe();
  const elements = useElements();
  const buttonRef = useRef(null);
  const [showPromoBtn, setShowPromoBtn] = useState(false);
  const [promoCode, setPromoCode] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    submitBtnHandler(false);

    if (elements == null) {
      return;
    }

    const { error, token } = await stripe.createToken(
      elements.getElement(CardNumberElement)
    );
    // const { error, paymentMethod } = await stripe.createPaymentMethod({
    //   type: "card",
    //   card: elements.getElement(CardNumberElement),
    // });

    if (error) {
      console.log("[error]", error);
      dispatch(
        showNotificationWithTimeout(
          `${error?.message ?? "Something went wrong!"}`,
          "error"
        )
      );
    } else {
      console.log("[token]", token);
      dispatch(
        saveSetupWizardForm("nine", {
          token:
            process?.env?.REACT_APP_TYPE == "production"
              ? token?.id
              : "tok_visa",
        })
      );
    }
  };

  const promoCodeHandler = () => {
    if (promoCode === "") {
      dispatch(
        showNotificationWithTimeout("Please enter valid promocode!", "error")
      );
      return;
    }
    dispatch(
      applyPromocodeWizard({
        promo_code: promoCode,
        id: purchased_plan?.id ?? 0,
      })
    );
  };
  const removePromoCodeHandler = () => {
    dispatch(
      removePromocodeWizard({
        id: purchased_plan?.id ?? 0,
      })
    );
  };

  const checkPromoApplied = checkNull(purchased_plan?.promo_code, false);

  return (
    <form onSubmit={handleSubmit}>
      {/* <CardElement /> */}
      <ul className="ingredient-info edit-shift paymentForm px-0">
        <li>
          <label>Card number</label>
          <div className="input-group">
            <CardNumberElement
              options={{ showIcon: true }}
              onReady={() => {
                console.log("CardNumberElement [ready]");
              }}
              onChange={(event) => {
                console.log("CardNumberElement [change]", event);
              }}
              onBlur={() => {
                console.log("CardNumberElement [blur]");
              }}
              onFocus={() => {
                console.log("CardNumberElement [focus]");
              }}
            />
          </div>
        </li>
        <li>
          <label>Expiration date</label>
          <div className="input-group">
            <CardExpiryElement
              onReady={() => {
                console.log("CardNumberElement [ready]");
              }}
              onChange={(event) => {
                console.log("CardNumberElement [change]", event);
              }}
              onBlur={() => {
                console.log("CardNumberElement [blur]");
              }}
              onFocus={() => {
                console.log("CardNumberElement [focus]");
              }}
            />
          </div>
        </li>

        <li>
          <label>CVC</label>
          <div className="input-group">
            {" "}
            <CardCvcElement
              onReady={() => {
                console.log("CardNumberElement [ready]");
              }}
              onChange={(event) => {
                console.log("CardNumberElement [change]", event);
              }}
              onBlur={() => {
                console.log("CardNumberElement [blur]");
              }}
              onFocus={() => {
                console.log("CardNumberElement [focus]");
              }}
            />
          </div>
        </li>
        <button
          type="submit"
          disabled={!stripe || !elements}
          style={{ display: "none" }}
          ref={buttonRef}
        >
          Pay
        </button>
      </ul>

      <ul className="ingredient-info edit-shift mb-5 px-0">
        {!showPromoBtn && !checkPromoApplied && (
          <li className="promolink">
            <a onClick={() => setShowPromoBtn(true)} className="green-txt link">
              Apply Promo Code
            </a>
          </li>
        )}
        {showPromoBtn && !checkPromoApplied && (
          <li id="promoblock">
            <label className="">Promo Code</label>
            <div className="input-group span7">
              <div className="promohide d-flex" id="promoCblock">
                <input
                  name="promo_code"
                  id="promo_code_val"
                  className="valid half"
                  type="text"
                  placeholder="Enter promo code"
                  value={promoCode}
                  onChange={(e) => {
                    setPromoCode(e?.target?.value);
                  }}
                />
                <button
                  id="apply_promo_code"
                  type="button"
                  className="btn_btnblue left-radius-0"
                  onClick={() => promoCodeHandler()}
                >
                  Apply Promo Code
                </button>
              </div>
            </div>
          </li>
        )}
        {checkPromoApplied && (
          <li id="promoblock">
            <label className="">Promo Code</label>
            <div className="input-group span7">
              <div className="promohide d-flex" id="promoCblock">
                <div className="col-9">
                  <p
                    class="applied"
                    id="promoMblock"
                    style={{ display: "block" }}
                  >
                    {" "}
                    Promotion Code "{checkPromoApplied}" has been applied.{" "}
                  </p>
                </div>
                <div className="col-3">
                  <button
                    id="apply_promo_code"
                    type="button"
                    className="btn_btnblue left-radius-0"
                    onClick={() => removePromoCodeHandler()}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </li>
        )}
      </ul>
    </form>
  );
};

const stripePromise = loadStripe("pk_test_6pRNASCoBOKtIshFeQd4XMUh");

const StripePayment = ({ isSubmit, submitBtnHandler, purchased_plan }) => (
  <Elements stripe={stripePromise}>
    <CheckoutForm
      isSubmit={isSubmit}
      submitBtnHandler={submitBtnHandler}
      purchased_plan={purchased_plan}
    />
  </Elements>
);
export default StripePayment;
